

























































import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/agiles/common';

@Component
export default class GroupView extends Vue {
  public items: Common.Group[] = new Array();
  public params: Common.GroupQuery = new Common.GroupQuery();
  public importQuery = new Common.UserImportQuery('グループ',true);//new Common.ImportQuery('グループ', 'User');
  public exportQuery = new Common.GroupExportQuery('グループ', this.params);

  public sortOptions: any = [
    { value: 'id', text: 'グループID' },
    { value: 'name', text: 'グループ名' },
  ];

  public listItems: Common.GroupMember[];

  public created(){
    this.$api.formatter.ensureListLoaded('user').then(()=>{
      this.listItems = this.$api.formatter.getOptions('user').map(obj => new Common.GroupMember(obj.value, null));
    });    
  }  
}
